import { render, staticRenderFns } from "./PromotionPoster.vue?vue&type=template&id=d3691dca&scoped=true"
import script from "./PromotionPoster.vue?vue&type=script&lang=js"
export * from "./PromotionPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3691dca",
  null
  
)

export default component.exports